import React from "react";
import DataTable from "react-data-table-component";
import { Toaster, toast } from "react-hot-toast";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import CreateCampaignTypeModal from "../Components/CreateCampaignTypeModal";
import EditCampaignTypeModal from "../Components/EditCampaignTypeModal";
import { useCampaignTypeTable } from "../hooks/useCampaignTypeTable";
import { getCampaignTypeTableColumns } from "../Components/CampaignTypeTableColumns";
import { CampaignTypeFormData } from "../types/campaignType.types";

const CampaignTypeTable: React.FC = () => {
  const {
    isSidebarCollapsed,
    toggleSidebar,
    isLoading,
    loading,
    error,
    searchText,
    setSearchText,
    filteredCampaignTypes,
    fetchCampaignTypeData,
    isModalOpen,
    setIsModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    editCampaignTypeId, // Changed from editCampaignTypeData
    setEditCampaignTypeId, // Changed from setEditCampaignTypeData
    selectedRows,
    toggleCleared,
    handleRowSelected,
    handleEdit,
  } = useCampaignTypeTable();

  const handleCreateCampaignType = (data: CampaignTypeFormData) => {
    toast.success(`Campaign type created successfully`);
    fetchCampaignTypeData();
  };

  const handleEditSubmit = (updatedData: CampaignTypeFormData) => {
    console.log("Updated campaign type data:", updatedData);
    setIsEditModalOpen(false);
    setEditCampaignTypeId(null);
    fetchCampaignTypeData();
    toast.success("Campaign type updated successfully");
  };

  const columns = getCampaignTypeTableColumns(handleEdit);

  if (loading) {
    return <div className="p-4 text-center">Loading campaign types...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="wrapper">
      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={{
          zIndex: 10000,
        }}
      />
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-header carHeaderWithBtn">
                      <div className="card-title mb-0">Campaign Types List</div>
                      <div>
                        <input
                          type="text"
                          placeholder="Search by Campaign Type Name"
                          className="p-2 w-full datatableSearchInput"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button
                          className="demo-btn btn btn-outline-primary btn-sm"
                          onClick={() => setIsModalOpen(true)}
                        >
                          +Add Campaign Type
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <DataTable
                        columns={columns}
                        data={filteredCampaignTypes}
                        pagination
                        paginationPerPage={10}
                        highlightOnHover
                        striped
                        responsive
                        noDataComponent="No campaign types found."
                        selectableRows
                        selectableRowsComponentProps={{
                          className: "custom-checkbox",
                        }}
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleCleared}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CreateCampaignTypeModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onSubmit={handleCreateCampaignType}
            />
            <EditCampaignTypeModal
              isOpen={isEditModalOpen}
              onClose={() => {
                setIsEditModalOpen(false);
                setEditCampaignTypeId(null);
              }}
              onSubmit={handleEditSubmit}
              campaignTypeId={editCampaignTypeId} // Changed from editCampaignTypeData
            />
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CampaignTypeTable;
